import React from 'react';

import styles from './SpecialPublicationPreAccessDetailsStyles.scss';

type SpecialPublicationPreAccessDetailsProps = {
  title: string;
  description: string;
};

const SpecialPublicationPreAccessDetails: React.FunctionComponent<SpecialPublicationPreAccessDetailsProps> = ({
  title,
  description
}): React.ReactElement => {
  return (
    <div className={styles.container}>
      <h3>{title}</h3>
      <p className={styles.instructions}>Complete the form on this page to download this paper.</p>
      <p>{description}</p>
    </div>
  );
};

export default SpecialPublicationPreAccessDetails;
